<template>
    <AppTabLinks :links="list" />
</template>

<script>
    import { mapState } from 'vuex';
    import AppTabLinks from '@/components/AppTabLinks'

    export default {
        components: {
            AppTabLinks
        },
        computed: {
            ...mapState('auth', ['user']),
            isAdmin() {
                return this.user.admin;
            },
            list() {
                return [
                    {
                        title: 'Карточка',
                        url: `/collections/${this.$route.params.id}/detail`,
                        disabled: !this.$route.params.id
                    },
                    {
                        title: 'Редактировать',
                        url: this.$route.params.id ? `/collections/${this.$route.params.id}/edit` : `/collections/edit`
                    },
                    {
                        title: 'Сайты',
                        url: `/collections/${this.$route.params.id}/sites`,
                        disabled: !this.$route.params.id
                    },
                ]
            }
        },
        mounted() {
        },
    }
</script>
